import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFAllHoldingsUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult() {
        return await this.Repo.mfAllHoldings();
    }
}
export default MFAllHoldingsUseCase;
